module.exports = __webpack_public_path__ + "assets/cross.6e380a1a6f438e68296e2c9dcbe4d460.svg";